<template>
  <painel-component :items="itemsOne">
    <form>
      <row-component>
        <col-component
          class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12"
        >
          <label>Nome:</label>
          <input-component v-model="formData.name" placeholder="Nome" />
        </col-component>

        <col-component
          class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
        >
          <label>Status:</label>
          <MultiSelect
            v-model="formData.status"
            placeholder="Status"
            :options="selectActiveInative"
          />
        </col-component>
      </row-component>

      <row-component>
        <col-component
          class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
        >
          <button-submit
            @click="submit"
            class="me-1"
            icon="search"
            name="Pesquisar"
          />
          <button-route v-if="buttonCheck.create" :items="itemsTwo" />
        </col-component>
      </row-component>
    </form>

    <div class="bg-body-secondaryd">
      <div class="bg-white">
        <div class="__table">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col" style="width: 45%">Nome</th>
                <th scope="col" style="width: 45%">Status</th>
                <th
                  scope="col"
                  style="width: 10%"
                  v-if="buttonCheck.edit || buttonCheck.delete"
                >
                  Ações
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(data, index) in object.data" :key="index">
                <td data-label="Nome">{{ data.name }}</td>
                <td data-label="Status">{{ statusString(data.status) }}</td>
                <td
                  data-label="Ações"
                  v-if="buttonCheck.edit || buttonCheck.delete"
                >
                  <button-edit
                    class="me-1"
                    :id="data.id"
                    route="user-group-edit"
                    v-if="buttonCheck.edit"
                  />
                  <button-delete
                    @click="destroy(data)"
                    v-if="buttonCheck.delete"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <button-pagination :pagination="object" :offset="3" @paginate="loadItems" />
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import ColComponent from '@/components/row/ColComponent';
import InputComponent from '@/components/form/InputComponent';
import MultiSelect from '@/components/form/MultiSelect';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonDelete from '@/components/buttons/ButtonDelete';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonPagination from '@/components/buttons/ButtonPagination';

import swal from 'sweetalert';
import { useToast } from 'vue-toastification';

const toast = useToast();
export default {
  name: 'UserGroupSearch',

  components: {
    ButtonPagination,
    ButtonRoute,
    ButtonSubmit,
    ButtonDelete,
    ButtonEdit,
    MultiSelect,
    InputComponent,
    ColComponent,
    RowComponent,
    PainelComponent
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Grupo de Usuário');
    this.loadItems(1);
    this.checkACL();
  },

  data() {
    return {
      itemsOne: {
        title: 'Pesquisar',
        icon: 'list alternate'
      },

      itemsTwo: {
        route: '/user-group/create',
        icon: 'plus',
        name: 'Adicionar'
      },

      buttonCheck: {
        create: false,
        edit: false,
        delete: false
      },

      formData: {
        name: '',
        status: ''
      },

      searchSubmit: false
    };
  },

  methods: {
    submit() {
      this.loadItems(1);
      this.searchSubmit = true;
    },

    loadItems(page) {
      if (!this.searchSubmit) {
        this.$store
          .dispatch('loadUserGroups', { ...this.params, page })
          .then(r => {
            if (this.searchSubmit) {
              this.searchSubmit = false;
              if (r.data.length === 0) {
                toast.info(
                  'Nada foi encontrado com os parâmetros informados!',
                  { timeout: 2000 }
                );
              }
            }
          })
          .catch(() => {
            this.searchSubmit = false;
          });
      }
    },

    destroy(item) {
      if (item.id === this.me.id) {
        toast.info('Você não pode excluir o próprio grupo!', { timeout: 1500 });
        return false;
      }
      swal({
        title: 'Atenção!',
        text: `Deseja realmente deletar ${item.name}, ${this.me.name} ?`,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: 'Não',
            visible: true,
            closeModal: true
          },
          confirm: 'Sim'
        }
      }).then(result => {
        if (result) {
          this.$store
            .dispatch('destroyUserGroup', item.id)
            .then(() => {
              this.loadItems(1);
              toast.success('Cadastro deletado com sucesso', { timeout: 1500 });
            })
            .catch(() => {
              toast.error(`Não foi possível deletar  ${item.name} `, {
                timeout: 1500
              });
            });
        }
      });
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 1)
        .then(r => {
          if (r.indexOf('group-user-search') !== -1) {
            if (r.indexOf('group-user-create') !== -1) {
              this.buttonCheck.create = true;
            }

            if (r.indexOf('group-user-edit') !== -1) {
              this.buttonCheck.edit = true;
            }

            if (r.indexOf('group-user-delete') !== -1) {
              this.buttonCheck.delete = true;
            }
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    },

    statusString(value) {
      if (parseInt(value) === 1) return 'Ativo';
      return 'Inativo';
    }
  },

  computed: {
    me() {
      return this.$store.state.auth.me;
    },

    selectActiveInative() {
      return this.$store.state.var.selectActiveInative;
    },

    object() {
      return this.$store.state.user_group.items;
    },

    params() {
      return {
        page: this.object.current_page,
        name: this.formData.name,
        status: this.formData.status
      };
    }
  }
};
</script>
